import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row g-3" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger mt-3"
}
const _hoisted_13 = {
  key: 1,
  class: "text-muted mt-3"
}
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = { class: "d-flex gap-2 justify-content-end" }

import { onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownClientes from "@/components/Dropdowns/DropdownClientes.vue";

import * as service from "@/services/vouchersService";


export default /*@__PURE__*/_defineComponent({
  __name: 'Cadastro',
  setup(__props) {

const route  = useRoute();
const router = useRouter();

const statusOpcoes = [
  { valor: service.eVoucherStatus.Pendente,  descricao: "Pendente"  },
  { valor: service.eVoucherStatus.Pago,      descricao: "Pago"      },
  { valor: service.eVoucherStatus.Cancelado, descricao: "Cancelado" },
];

const controle = reactive({
  model: {
    voucherId:   0,
    vendedorId:  null,
    indicadorId: null,
    indicadoId:  null,
    valor:       0,
    status:      service.eVoucherStatus.Pendente,
    dataPagamento: null,
    dataCartao:    null,
  } as unknown as service.Voucher,
  notificacao: { exibir: false, mensagem: "", tipo: "success" },
  status: "",
  erro:   "",
});

onMounted(() => {
  if (route.params.id) {
    controle.status = "Carregando...";
    service.obterPorId(Number(route.params.id))
      .then(r => { controle.model = r; controle.status = ""; })
      .catch(e => { controle.erro = e.message || String(e); controle.status = ""; });
  }
});

async function salvar() {
  controle.erro   = "";
  controle.status = "Salvando...";
  try {
    await service.salvar(controle.model);
    controle.status = "";
    controle.notificacao = { exibir: true, mensagem: "Salvo com sucesso!", tipo: "success" };
    setTimeout(() => router.push("/vouchers"), 1200);
  } catch (e: any) {
    controle.status = "";
    controle.erro   = e.message || String(e);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Vouchers",
      SubTitle: "Cadastro"
    }),
    _createVNode(Notificacao, {
      exibir: controle.notificacao.exibir,
      mensagem: controle.notificacao.mensagem,
      tipo: (controle.notificacao.tipo as any),
      onOnFechou: _cache[0] || (_cache[0] = ($event: any) => (controle.notificacao.exibir = false))
    }, null, 8, ["exibir", "mensagem", "tipo"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, [
              _createTextVNode("Indicador "),
              _createElementVNode("small", { class: "text-muted" }, "(quem indicou)")
            ], -1)),
            _createVNode(DropdownClientes, {
              modelValue: controle.model.indicadorId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((controle.model.indicadorId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, [
              _createTextVNode("Indicado "),
              _createElementVNode("small", { class: "text-muted" }, "(novo cliente)")
            ], -1)),
            _createVNode(DropdownClientes, {
              modelValue: controle.model.indicadoId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.model.indicadoId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Vendedor", -1)),
            _createVNode(DropdownVendedores, {
              modelValue: controle.model.vendedorId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((controle.model.vendedorId) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Valor (R$)", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              step: "0.01",
              min: "0",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((controle.model.valor) = $event))
            }, null, 512), [
              [_vModelText, controle.model.valor]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Status", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((controle.model.status) = $event))
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOpcoes, (op, i) => {
                return _createElementVNode("option", {
                  key: i,
                  value: op.valor
                }, _toDisplayString(op.descricao), 9, _hoisted_9)
              }), 64))
            ], 512), [
              [_vModelSelect, controle.model.status]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Data de Pagamento", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (((controle.model as any).dataPagamento) = $event))
            }, null, 512), [
              [_vModelText, (controle.model as any).dataPagamento]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "Data Cartão", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (((controle.model as any).dataCartao) = $event))
            }, null, 512), [
              [_vModelText, (controle.model as any).dataCartao]
            ])
          ])
        ]),
        (controle.erro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(controle.erro), 1))
          : _createCommentVNode("", true),
        (controle.status)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(controle.status), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_RouterLink, {
            class: "btn btn-secondary btn-sm",
            to: "/vouchers"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("Cancelar", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (salvar()))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("i", { class: "flaticon-check" }, null, -1),
            _createTextVNode(" Salvar ", -1)
          ]))])
        ])
      ])
    ])
  ], 64))
}
}

})